import React, { type FC } from "react";
import "./styles/index.scss";
import { AppRouter } from "./router";

const App: FC = () => <AppRouter />;

export default App;
